import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import axios from "axios";

import "./index.css";

export default class extends Controller {
  connect() {
    const elm = this.element;
    const handle = elm.dataset.sortableHandleValue;
    const lockAxis = elm.dataset.sortableLockAxisValue;
    const sortableUrl = elm.dataset.sortableUrl;
    const sortableMethod = elm.dataset.sortableMethod;
    const sortableGroup = elm.dataset.sortableGroup || "shared";

    new Sortable(elm, {
      handle: handle,
      swapThreshold: 1,
      animation: 0,
      group: sortableGroup,
      direction:
        lockAxis === "horizontal"
          ? "horizontal"
          : lockAxis === "vertical"
            ? "vertical"
            : undefined,
      filter: (e) => {
        return (
          e.target.closest("[data-ui--confirm-target='confirmModal']") ||
          e.target.closest("[role='menu']") ||
          e.target.closest("[data-controller='modal']") ||
          e.target.closest("[data-controller='dropdown-menu']")
        );
      },
      onMove: (evt) => {
        const item = evt.dragged;
        const target = evt.to;
        return (
          item.dataset.sortableLevel === target.dataset.sortableAcceptLevel
        );
      },
      onEnd: (evt) => {
        evt.item.style.opacity = "";

        const ids = Array.from(evt.to.children).map(
          (child) => child.dataset.id,
        );
        let data;

        data = ids.map((id, index) => ({
          id: id,
          position: index,
        }));

        axios({
          url: sortableUrl,
          data: JSON.stringify({ sortable_items: data }),
          method: sortableMethod,
          headers: { "content-type": "application/json" },
        }).then((response) => {
          try {
            Turbo.renderStreamMessage(response.data);
          } catch (err) {
            console.error(err);
          }
        });
      },
    });
  }
}
